import { FC, useEffect, useState } from "react";
import { RadialBarChart, RadialBar, Legend } from "recharts";
import { Oval } from "react-loader-spinner";
import "./Radialbar.css";

interface IRadialbarProps {
  score: { score: number | null; job: number | null };
  loader: boolean;
}

interface IData {
  profile: resultProfileEnum;
  name?: string;
  score: number;
  fill: string;
}

enum resultProfileEnum {
  UNDISPLAY,
  USER,
  JOB,
}

const Radialbar: FC<IRadialbarProps> = ({ score, loader }) => {
  const [data, setData] = useState<Array<IData>>([]);

  const initialData = (score: number) => {
    return [
      {
        profile: resultProfileEnum.UNDISPLAY,
        score: 100,
        fill: "#FFFFFF",
      },
      {
        profile: resultProfileEnum.USER,
        name: `${score} %`,
        score: score,
        fill: "#3E8FC6",
      },
    ];
  };

  const setJobData = () => {
    const profileJobExists = data.some(
      (item) => item.profile === resultProfileEnum.JOB
    );
    if (profileJobExists) {
      const dataWithReplacedJob = data.map((item: IData) => {
        if (item.profile === resultProfileEnum.JOB) {
          return {
            ...item,
            name: `${score.job} %`,
            score: score.job as number,
          };
        }
        return item;
      });

      return dataWithReplacedJob;
    }

    return [
      ...data,
      {
        profile: resultProfileEnum.JOB,
        name: `${score.job} %`,
        score: score.job as number,
        fill: "#F8485E",
      },
    ];
  };

  const setUserScore = (globalScore: {
    score: number | null;
    job: number | null;
  }) => {
    if (globalScore.score) {
      const initializedData = initialData(globalScore.score);
      if (data.length) {
        const updatedData = setJobData();
        if (updatedData[2].score === 0) {
          updatedData.splice(-1);
          setData(updatedData);
        }
        setData(updatedData);
      } else {
        setData(initializedData);
      }
    }
  };

  const loading = () => {
    return (
      <Oval
        height={120}
        width={120}
        color="#3e8fc6"
        wrapperStyle={{alignItems:'center', justifyContent:"content"}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#3e8fc6"
        strokeWidth={5}
        strokeWidthSecondary={5}
      />
    );
  };

  useEffect(() => {
    setUserScore(score);
    // eslint-disable-next-line
  }, [score]);

  return (
    <div className="userResultScore">
      <h3>SCORE GLOBAL</h3>
      {loader ? (
        loading()
      ) : (
        <div className="radialBar">
          <RadialBarChart
            width={160}
            height={160}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={70}
            barSize={25}
            data={data ? data : [0]}
            startAngle={90}
            endAngle={450}
          >
            <RadialBar dataKey="score" isAnimationActive={true} />
            <Legend
              align="center"
              layout="vertical"
              iconSize={0}
              wrapperStyle={{
                top: "50%",
                left: "50%",
                transform: "translate(-45%,-65%) scaleX(-1)",
              }}
            />
          </RadialBarChart>
        </div>
      )}
    </div>
  );
};

export default Radialbar;
